import Translation from "@Translation/components/Translation";
import IconChevron from "@Icons/chevrons/IconChevron";
import React from "react";

interface ReadMoreButtonProps {
    readMore: () => void,
}

function ReadMoreButton({readMore}: ReadMoreButtonProps) {
    return (
        <button
            type="button"
            className="gb--emphasize-info"
            onClick={readMore}
        >
            <Translation translationKey="sys.read_more"/>
            &nbsp;
            <IconChevron fill="#4a79e2"/>
        </button>
    )
}

export default ReadMoreButton